module.exports = __webpack_public_path__ + "static/img/noData.030e6303.png";